import NonCriticalError from '@/errors/NonCriticalError.js';

class Login2faNecessaryError extends NonCriticalError {
}

export default Login2faNecessaryError;
